// /Users/stuartmcgeer/portalworx/frontend/src/components/buttons/ViewButton.tsx

import React from 'react';
import styled from 'styled-components';
import { FaEye } from 'react-icons/fa';

// Styled button component for viewing actions, such as viewing details
const StyledButton = styled.button`
    background-color: #0270ff;
    color: white;
    height: 2.5rem; 
    border: none;
    border-radius: 0.5rem;
    padding: 0.4rem 0.75rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #004ea2;
    }

    &:disabled {
        background-color: #a1c9f1;
        cursor: not-allowed;
    }
`;

// Props for the ViewButton component
interface ViewButtonProps {
    onClick: () => void; // Function to handle the click event
    disabled?: boolean; // Optional prop to disable the button
    label?: string; // Optional label to display next to the icon
    className?: string; // Optional custom CSS class
}

// Functional component for a view button, commonly used for viewing details
const ViewButton: React.FC<ViewButtonProps> = ({ onClick, disabled = false, label, className = '' }) => (
    <StyledButton className={className} onClick={onClick} disabled={disabled} aria-label={label || 'View'}>
        <FaEye size={18} />
        {label}
    </StyledButton>
);

export default ViewButton;
